var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"pb-0"},[_c('a',{staticClass:"text-info cursor-pointer",attrs:{"href":_vm.supplierDetailsPagePath},on:{"click":_vm.handleRowClick}},[_vm._v("\n    \t  "+_vm._s(_vm.value?.name)+"\n\t ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }